"use client"

import { Frown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FrownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FrownIcon = component(Icon)({ as: Frown })
